module.exports = __webpack_public_path__ + "assets/img/Own Goal.webp?9bdc91d34098bc520272f49920d46e89";